import { network } from 'services/network';

export const getAiTaskMitigation = (params) => {
    return network.post('api/bo/chat/getAiTaskMitigation', params).then((response) => {
        return response.data;
    });
};
